import Pixel from './Pixel';
import cleanCategory from './cleanCategoryName';

export const maybeHandle = (oneTrustCategory, fn, shouldQueue) => {
	const category = cleanCategory(oneTrustCategory);
	if (typeof category === 'undefined') {
		return fn();
	}

	const pixel = new Pixel(category, fn, shouldQueue);
	return pixel.createTrigger()();
};
